import React, { useReducer, useState } from 'react';
import { connect } from 'react-redux';
import xor from 'lodash/xor';

import { Grid, Cell, GridContainer } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import useIsMobile from '../../../hooks/useIsMobile';
import DisplayStyleControl from './DisplayStyleControl';
import Filters from './Filters';
import Products from './Products';
import SortControl from './SortControl';

import './FilteredProductList.module.css';

const initFilterState = filters =>
  filters.reduce((result, entry) => ({ ...result, [entry]: [] }), {});

const filterReducer = (state, action) => {
  switch (action.type) {
    case 'set':
      // toggle existing entries
      const activeOptions = xor(
        state[action.payload.id],
        action.payload.option
      );
      return {
        ...state,
        [action.payload.id]: activeOptions
      };
    case 'reset':
      if (typeof window !== 'undefined')
        window.history.replaceState(null, '', window.location.pathname);
      return initFilterState(action.payload);
    default:
      throw new Error();
  }
};

const FilteredProductList = ({
  availableFilters = ['compatible_printer', 'material_family'],
  category = 27,
  categoryName = 'Materials',
  initialDisplayStyle = 'grid',
  vertical = 'flat',
  storeId
}) => {
  const [productCount, setProductCount] = useState(0);
  const [order, setOrder] = useState('default');
  const [displayStyle, setDisplayStyle] = useState(initialDisplayStyle);
  const [filters, dispatchFilters] = useReducer(
    filterReducer,
    availableFilters,
    initFilterState
  );

  const updateFilterAction = (id, option) => {
    dispatchFilters({
      type: 'set',
      payload: {
        id,
        option
      }
    });
  };

  const resetFilterAction = () => {
    dispatchFilters({ type: 'reset', payload: availableFilters });
  };

  const activeFilterCount = Object.keys(filters).reduce(
    (count, filter) => count + filters[filter].length,
    0
  );

  const isMobile = useIsMobile(640);

  return (
    <GridContainer>
      <Grid direction="x" gutters="margin">
        <Cell mediumSize={6}>
          {!isMobile && (
            <Filters
              {...{
                availableFilters,
                activeFilterCount,
                filters,
                updateFilterAction,
                resetFilterAction,
                storeId
              }}
            />
          )}
        </Cell>
        <Cell mediumSize={18}>
          <div styleName="tools">
            <Header level={1} displayAs={4}>
              {categoryName}
            </Header>
            {!isMobile ? (
              <SortControl {...{ productCount, setOrder, order }} />
            ) : (
              <Filters
                {...{
                  availableFilters,
                  activeFilterCount,
                  filters,
                  updateFilterAction,
                  resetFilterAction,
                  storeId
                }}
              >
                <div style={{ margin: 'auto', width: '95%' }}>
                  <SortControl {...{ productCount, setOrder, order }} />
                </div>
              </Filters>
            )}
            <DisplayStyleControl {...{ displayStyle, setDisplayStyle }} />
          </div>
          <Grid direction="x">
            <Products
              {...{
                activeFilterCount,
                category,
                displayStyle,
                filters,
                order,
                resetFilterAction,
                setProductCount,
                storeId,
                vertical
              }}
            />
          </Grid>
        </Cell>
      </Grid>
    </GridContainer>
  );
};

export default connect(state => {
  return {
    storeId: state.store.id
  };
})(FilteredProductList);
